import { useRef, useEffect, useState } from "react";
import style from "./SaasHeadManage.module.scss";
import { Input } from "antd";
import func from "@uikit/func";
import { logEvent } from "@uikit/service/amplitude";
import LoadingOutline from "@views/components/LoadingOutline";
import { useAISaasContainer } from "@uiview/views/AISaas/container";
import { useRenderData } from "@uiview/views/AISaas/hooks/useRenderData";
import { useAISaasPreviewItem } from "../../hooks/useAISaasPreviewItem";

const SaasHeadManage = props => {
  const titleBoxRef = useRef(null);
  const titleSubRef = useRef(null);
  const titleRef = useRef(null);
  const [showEditTitle, setShowEditTitle] = useState(false);
  const [showTitle, setShowTitle] = useState(props.saasUIData?.showTitle || true);
  const [saasTitle, setSaasTitle] = useState(props.saasUIData?.title || "");
  const [saasTitleStyle, setSaasTitleStyle] = useState({
    fontFamily: "Ak-Regular",
    fontSize: "36px",
    textAlign: "center",
    fontWeight: 500,
  });

  const subTitleRef = useRef(null);
  const [showEditSubTitle, setShowEditSubTitle] = useState(false);
  const [showSubTitle, setShowSubTitle] = useState(props.saasUIData?.showSubTitle || true);
  const [saasSubTitle, setSaasSubTitle] = useState(props.saasUIData?.subTitle || "");
  const [saasSubTitleStyle, setSaasSubTitleStyle] = useState({
    fontFamily: "Ak-Regular",
    fontSize: "16px",
    textAlign: "center",
    lineHeight: "25px",
  });

  const { previewHoverData, onPreviewItemMouseEnter, onPreviewItemMouseLeave } = useAISaasPreviewItem();

  const hideAndDisplay = key => {
    return key ? style["display-box"] : style["hide-box"];
  };
  // title
  const onTitleChange = e => {
    setSaasTitle(e.target.value);
  };

  const onTitlePressEnter = e => {
    e.preventDefault();
    setShowEditTitle(false);
    clickTitleStyleSave(saasTitleStyle);
  };

  const clickTitleEdit = () => {
    setShowTitle(true);
    setShowEditTitle(true);
    if (!func.isEmpty(titleRef.current)) {
      titleRef.current.focus({
        cursor: "end",
      });
    }
    logEvent("click_edit", { target: "title" });
  };
  const clickCloseTitle = () => {
    setSaasTitle(props.saasUIData?.title || "");
    setShowEditTitle(false);
    props.setSaasUIData(prevData => {
      return Object.assign({}, prevData, { showTitle: false, title: "" });
    });
    logEvent("click_edit", { target: "title", delete: true });
  };
  const clickTitleStyleSave = styleData => {
    setShowEditTitle(false);
    props.setSaasUIData(prevData => {
      return Object.assign({}, prevData, { titleStyle: styleData, title: saasTitle, showTitle: showTitle });
    });
  };
  // sub title
  const onSubTitleChange = e => {
    setSaasSubTitle(e.target.value);
  };

  const onSubTitlePressEnter = e => {
    e.preventDefault();
    setShowEditSubTitle(false);
    clickSubTitleStyleSave(saasSubTitleStyle);
  };

  const clickSubTitleEdit = () => {
    setShowSubTitle(true);
    setShowEditSubTitle(true);
    if (!func.isEmpty(subTitleRef.current)) {
      subTitleRef.current.focus({
        cursor: "end",
      });
    }
    logEvent("click_edit", { target: "sub" });
  };
  const clickSubCloseTitle = () => {
    setSaasSubTitle(props.saasUIData?.subTitle || "");
    setShowEditSubTitle(false);
    props.setSaasUIData(prevData => {
      return Object.assign({}, prevData, { showSubTitle: false, subTitle: "" });
    });
    logEvent("click_edit", { target: "sub", delete: true });
  };
  const clickSubTitleStyleSave = styleData => {
    setShowEditSubTitle(false);
    props.setSaasUIData(prevData => {
      return Object.assign({}, prevData, {
        subTitleStyle: styleData,
        subTitle: saasSubTitle,
        showSubTitle: showSubTitle,
      });
    });
  };

  useEffect(() => {
    setSaasTitle(props.saasUIData?.title || "");
  }, [props.saasUIData?.title]);
  useEffect(() => {
    setSaasSubTitle(props.saasUIData?.subTitle || "");
  }, [props.saasUIData?.subTitle]);
  useEffect(() => {
    setShowTitle(func.isEmpty(props.saasUIData?.showTitle) ? true : props.saasUIData?.showTitle);
    setShowSubTitle(func.isEmpty(props.saasUIData?.showSubTitle) ? true : props.saasUIData?.showSubTitle);
  }, [props.saasUIData]);

  const titleRenderData = useRenderData({ type: "title" });
  const subtitleRenderData = useRenderData({ type: "subtitle" });

  return (
    <div className={style["saasHeadManage"]}>
      {!props.showOutPut && props.saasLoading ? (
        <div className={style["saas-top"]}>
          <LoadingOutline />
        </div>
      ) : (
        <div className={style["saas-top"]}>
          <div
            ref={titleBoxRef}
            onMouseEnter={onPreviewItemMouseEnter.bind(null, {
              type: "title",
              container: titleBoxRef.current,
              edit: clickTitleEdit,
              remove: clickCloseTitle,
            })}
            onMouseLeave={onPreviewItemMouseLeave}
            className={style["title-box"]}
          >
            <div className={`${style["edit-box"]} ${hideAndDisplay(previewHoverData.type === "title")}`}></div>
            <div className={hideAndDisplay(showTitle)}>
              <div style={titleRenderData.style} className={`${style["saas-title"]} ${hideAndDisplay(!showEditTitle)}`}>
                {saasTitle}
              </div>
              <Input.TextArea
                style={titleRenderData.style}
                ref={titleRef}
                className={`title-textarea ${style["saas-title"]} ${hideAndDisplay(showEditTitle)} ${
                  showEditTitle ? style["display-zIndex"] : null
                }`}
                value={saasTitle}
                onChange={onTitleChange}
                onPressEnter={onTitlePressEnter}
                onBlur={onTitlePressEnter}
                bordered={false}
                autoSize
              />
            </div>
          </div>

          <div
            ref={titleSubRef}
            onMouseEnter={onPreviewItemMouseEnter.bind(null, {
              type: "description",
              container: titleSubRef.current,
              edit: clickSubTitleEdit,
              remove: clickSubCloseTitle,
            })}
            onMouseLeave={onPreviewItemMouseLeave}
            className={style["title-box"]}
          >
            <div className={`${style["edit-box"]} ${hideAndDisplay(previewHoverData.type === "description")}`}></div>
            <div className={hideAndDisplay(showSubTitle)}>
              <div
                style={subtitleRenderData.style}
                className={`${style["saas-subTitle"]} ${hideAndDisplay(!showEditSubTitle)}`}
              >
                {saasSubTitle}
              </div>
              <Input.TextArea
                style={subtitleRenderData.style}
                ref={subTitleRef}
                className={`subtitle-textarea ${hideAndDisplay(showEditSubTitle)} ${
                  showEditSubTitle ? style["display-zIndex"] : null
                }`}
                value={saasSubTitle}
                onChange={onSubTitleChange}
                onPressEnter={onSubTitlePressEnter}
                onBlur={onSubTitlePressEnter}
                bordered={false}
                autoSize
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SaasHeadManage;
